<template lang="pug">
    .periodsOrbits
        .period(v-for="period in periods" @click="$emit('changePeriod', period.id)")
            .dot(:style="{backgroundImage: 'url('+(period.events[0]&&period.events[0].icon)+')'}")
            .circle_red
            .date(v-html="period.date")
            .name(v-html="period.name")





</template>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";
    .periodsOrbits{
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;
        //background: url(../../assets/img/orbits-mobile.png) no-repeat center calc(95% - 35vw)/100% 62%;
        .period{
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 13vw;
            height: 13vw;
            border-radius: 50%;
            font-family: Pobeda;
            font-weight: bold;
            transform: translateX(-50%);
            &:nth-of-type(1){
                top: 13%;
                left: 33%;
            }
            &:nth-of-type(2){
                top: 13%;
                left: 68%;
            }
            &:nth-of-type(3){
                top: 27%;
                left: 14%;
            }
            &:nth-of-type(4){
                top: 27%;
                left: 50%;
            }
            &:nth-of-type(5){
                top: 27%;
                left: 86%;
            }
            &:nth-of-type(6){
                top: 50%;
                left: 14%;
            }
            &:nth-of-type(7){
                top: 50%;
                left: 86%;
            }
            &:nth-of-type(8){
                top: 79%;
                left: 14%;
            }
            &:nth-of-type(9){
                top: 79%;
                left: 50%;
            }
            &:nth-of-type(10){
                top: 79%;
                left: 86%;
            }
        }
        .dot{
            width: 100%;
            min-height: 100%;
            position: relative;
            z-index: 1;
            border-radius: 50%;
            background: no-repeat center center / cover;
        }
        .circle_red{
            position: absolute;
            bottom: -0.3%;
            left: -0.3%;
            width: 104%;
            height: 102%;
            background: url(../../assets/img/elements/hover/circle_red.png) no-repeat center center / 100% 100%;
        }
        .date{
            margin: 3vw 0 1vw;
            color: $red;
            font-size: 5vw;
            text-align: center;
            white-space: nowrap;
        }
        .name{
            display: none;
            color: #6c6c6c;
            font-size: 2.5vw;
            text-align: center;
            white-space: nowrap;
        }
        @include tablet{
            //background-position: center calc(141% - 35vw);
            //background-size: 100% 68%;
            .period{
                width: 9vw;
                height: 9vw;
            }
            .name, .date{
                width: 200%;
                margin: 0.5vw 0 0.5vw 0;
            }
        }

        @include razr570H{
            //background-position: center calc(111% - 35vw);
            //background-size: 100% 68%;
        }
    }

</style>
<script>
    export default {
        name: "PeriodsOrbits",
        props: ['periods'],

    }
</script>
<style lang="scss">
    .periodsOrbits .name br{
        display: none;
    }
</style>
